import(/* webpackMode: "eager", webpackExports: ["NavUser"] */ "/app/apps/web/src/app/[locale]/(space)/(dashboard)/components/sidebar/nav-user.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpaceSidebarMenu"] */ "/app/apps/web/src/app/[locale]/(space)/(dashboard)/components/sidebar/space-sidebar-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpaceSidebarProvider"] */ "/app/apps/web/src/app/[locale]/(space)/(dashboard)/components/sidebar/space-sidebar-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpgradeToProAlert"] */ "/app/apps/web/src/app/[locale]/(space)/(dashboard)/components/sidebar/upgrade-to-pro-alert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Trans"] */ "/app/apps/web/src/components/trans.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/features/navigation/command-menu/command-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpaceDropdown"] */ "/app/apps/web/src/features/space/components/space-dropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpaceIcon"] */ "/app/apps/web/src/features/space/components/space-icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpaceTierLabel"] */ "/app/apps/web/src/features/space/components/space-tier.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.1_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-_2336ead6c9af193fdc07ef65fb435775/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/packages/ui/src/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/app/packages/ui/src/icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/sidebar.tsx");
